import { Data } from "../Data";

export class SubmitBillingDetails extends Data {
  constructor(options: any) {
    super({
      api: "/Organization/Admin/Billing",
      postData: options.details,
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...options
    });
  }

  static post(context: any, details: any) {
    return new Promise(
      (resolve, reject) =>
        new SubmitBillingDetails({ resolve, reject, context, details, method: "post" })
    );
  }

  static put(context: any, details: any) {
    return new Promise(
      (resolve, reject) =>
        new SubmitBillingDetails({ resolve, reject, context, details, method: "put" })
    );
  }
}
